var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profile",
  fill: "#41505F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.459,15.9147487 C13.67775,15.4977487 14.09475,14.7164987 14.459,14.3522487 C14.92775,13.8834987 15.501,12.2692487 15.501,12.2692487 C16.4385,11.8522487 16.543,11.1754987 16.6465,10.7067487 C17.0635,9.35224865 16.0215,9.14424865 16.0215,9.14424865 C16.0215,9.14424865 16.8545,6.90499865 16.17775,5.18624865 C15.292,2.94699865 11.69825,2.11299865 11.07325,4.19699865 C6.80275,3.25852365 7.6875,9.14324865 7.6875,9.14324865 C7.6875,9.14324865 6.6455,9.35125615 7.0625,10.7057487 C7.1669925,11.1744987 7.2705075,11.8512487 8.208,12.2682487 C8.208,12.2682487 8.78125,13.8824987 9.25,14.3512487 C9.61425,14.7154987 10.03125,15.4967487 9.25,15.9137487 C7.6875,16.7467487 3,16.9557487 3,20.6012487 L20.7080003,20.6012487 C20.7089768,16.9557487 16.0215,16.7477487 14.459,15.9147487 Z",
  id: "Shape"
})))));
export { SvgProfile as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.ff8e3ec4.svg";